<template lang="pug">
div
  .h-vertical-align-container(v-if="modalShow")
    .modal__close(@click='overlay()')
    .modal__overlay(@click='overlay()')
    .videoModal__wrapper
      .fluid__video#fluid__video--tutorial(v-html='ytVideo') {{ytVideo}}

  section.full__video
    .intro__content.intro__content--mobile
      img.lazy#productLogo(data-srcset='https://cdn.flixel.com/static/static-web/products/mac/cinemagraphpro@2x.png 2x, https://cdn.flixel.com/static/static-web/products/mac/cinemagraphpro.png 1x')
      h2 Cinemagraphs Go Mobile
      .btn__group.btn__group--splash
        a.btn.btn--purpleLight.btn__splash(href='https://itunes.apple.com/app/cinemagraph-pro/id642139481?mt=8') Download free trial
        get-plan(classes='btn btn--white')
    .fluid__video
      .intro__content.intro__content--desktop
        img.lazy#productLogo(data-srcset='https://cdn.flixel.com/static/static-web/products/mac/cinemagraphpro@2x.png 2x, https://cdn.flixel.com/static/static-web/products/mac/cinemagraphpro.png 1x')
        h2 Cinemagraphs Go Mobile
        .btn__group.btn__group--splash
          a.btn.btn--purpleLight.btn__splash(href='https://itunes.apple.com/app/cinemagraph-pro/id642139481?mt=8') Download free trial
          get-plan(classes='btn btn--white btn__splash')
      iframe(data-src='https://media.flixel.com/cinemagraph/d8okz016leqi559mmoo6?hd=true' allow='autoplay')
      .credit
        a(target='_blank' href='https://flixel.com/VirgoHaan/') VirgoHaan

  brands

  section.product__section--ios
    .product__section.product__section--ios
      .product__section--container.product__section--reverse
        .product__section--content
          .productItem__title
            img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/products/ios/icons/cinemagraph-pro-ios-icon@2x.png 2x,https://cdn.flixel.com/static/static-web/products/ios/icons/cinemagraph-pro-ios-icon.png 1x')
            h2
              | Cinemagraph Pro
              span for iOS
          .productItem__desc
            p The magic and ease of Cinemagraph Pro right at your fingertips. Capture, edit and create professional quality cinemagraphs on-the-go with your iPhone or iPad.
            .btn__group
              a.btn.btn--black(href='https://itunes.apple.com/ca/app/cinemagraph-pro/id642139481?mt=8') Download free trial
              get-plan(classes='btn btn--white')
        .product__section--image
          img.lazy#iosImage(data-srcset='https://cdn.flixel.com/static/static-web/products/ios/cinemagraph-pro-ios@2x.png 2x, https://cdn.flixel.com/static/static-web/products/ios/cinemagraph-pro-ios.png 1x')

  section
    .product__section
      .product__section--highlights
        .highlights--title
          h2 Cinemagraph Pro for iOS is Your Mobile Creation Studio
          p Cinemagraph Pro for iOS lets you take professional cinemagraph production on-the-go. Create thumb-stopping cinemagraphs on an iPhone or iPad and share them instantly on social media, web, as Facebook ads, and more.

        .highlights
          .highlight__item
            .highlight__item--icon
              img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/products/ios/features/4kcinemagraphs@2x.png 2x, https://cdn.flixel.com/static/static-web/products/ios/features/4kcinemagraphs.png 1x')
            .highlight__item--title
              h3 4K Cinemagraphs From Your iPhone or iPad
            .highlight__item--desc
              p Cinemagraphs created with Cinemagraph Pro for iOS are based in video. The quality of video used to create your cinemagraph will be the quality of your export. You can even shoot, edit and share 4K Cinemagraphs with the iPhone 7 and iPad Pro, and tell your story as vividly as you would like.

          .highlight__item
            .highlight__item--icon
              img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/products/ios/features/apowerfulcinemagraph@2x.png 2x, https://cdn.flixel.com/static/static-web/products/ios/features/apowerfulcinemagraph.png 1x')
            .highlight__item--title
              h3 A Powerful Cinemagraph Creation Tool in Your Pocket
            .highlight__item--desc
              p Bring the entire cinemagraph creation process right to your fingertips. Capture or import your video, trim your clip, select your still image and paint over it to reveal the motion. Simple, and fast.

          .highlight__item
            .highlight__item--icon
              img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/products/ios/features/easytocreate@2x.png 2x, https://cdn.flixel.com/static/static-web/products/ios/features/easytocreate.png 1x')
            .highlight__item--title
              h3 Easy to Create. Easy to Share.
            .highlight__item--desc
              p Export your beautiful cinemagraphs directly to your social networks and share them instantly. You can even save your cinemagraph as a Facebook Profile video or export it as a Apple Live Photo and set it as your lock screen image. Upload your work to your Flixel gallery, where your cinemagraphs will live infinitely.

          .highlight__item
            .highlight__item--icon
              img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/products/ios/features/controlapplewatch@2x.png 2x, https://cdn.flixel.com/static/static-web/products/ios/features/controlapplewatch.png 1x')
            .highlight__item--title
              h3 Take Control with Your Apple Watch
            .highlight__item--desc
              p Your Apple Watch is your personal remote control. Capture your cinemagraph by setting a countdown timer, or use it as a remote shutter release so that you can perfect your cinemagraph selfie.

  section
    .product__section
      .product__section--video
        a(href='https://www.youtube.com/watch?v=OJ7kf2TfR24' @click='ytModal($event)')
          img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/products/ios/ios-cover@2x.png 2x, https://cdn.flixel.com/static/static-web/products/ios/ios-cover.png 1x')
          .playbtn

  section.product__section.product__section--callout
    .callout__title
      h1 Achieve Perfectly Looped Cinemagraphs
    .callout__text
      p Shoot perfectly still video footage using a digital camera on a tripod. Compose it like a photo with a repeated movement and capture it. Import your video into Cinemagraph Pro for macOS and let the magic begin.
    .btn__group
      a.btn.btn--purpleLight.btn__splash(href='https://itunes.apple.com/ca/app/cinemagraph-pro/id642139481?mt=8') Download free trial
      get-plan

  section
    .product__section
      .product__section--specs
        h2 System Requirements
        p iOS 11.0 or later. Compatible with iPhone, iPad, iPad Pro, iPod Touch, and Apple Watch.

  section.flixelPlan__section
    .flixelPlan__container
      h1 Choose a plan that’s right for you
      p Whether you’re a photographer, marketer, or designer, creating cinemagraphs is fun, fast, and easy with Cinemagraph Pro. Select a plan and start using the best cinemagraph creation tools and web-sharing platform.
      .btn__group
        get-plan(classes='btn btn--white')
  // Rich Card
  script(
    type="application/ld+json" 
    ) {{ this.$metaInfo}}
</template>

<script>
import Brands from 'components/Brands.vue';
import getPlan from 'components/getPlan.vue';
import productmixin from './productmixin.vue';

export default {
  name: 'ios-fcp',
  metaInfo() {
    return {
      title: 'Cinemagraph Pro for iOS | Flixel',
      meta: [
        {
          'property': 'image',
          'content': 'https://cdn.flixel.com/static/static-web/CinemagraphProiOS.png',
        },
        {
          'property': 'description',
          'content': 'The best app to create cinemagraphs on iOS for getting noticed in social media and digital advertising. Living photos on-the-go made fun, fast, and easy.',
        },
        {
          'property': 'richcard',
          'content': '{"@context":"https://schema.org","@type":"SoftwareApplication","name":"Cinemagraph Pro for iOS","description":"The best app to create cinemagraphs on iOS for getting noticed in social media and digital advertising. Living photos on-the-go made fun, fast, and easy.","image":["https://cdn.flixel.com/static/static-web/CinemagraphProiOS_1_1.png","https://cdn.flixel.com/static/static-web/CinemagraphProiOS_4_3.png","https://cdn.flixel.com/static/static-web/CinemagraphProiOS_16_9.png"],"downloadUrl":"https://appstore.com/apps/cinemagraphpro","operatingSystem":"iOS 11.0 and higher","storageRequirements":"100 MB","applicationCategory":"https://schema.org/SoftwareApplication","aggregateRating":{"@type":"AggregateRating","ratingValue":"4.6","bestRating":"5.0","ratingCount":"11289"},"offers":{"@type":"Offer","price":"14.99","priceCurrency":"USD"}}',
        },
      ],
      script: [
        {
          innerHTML: '{"@context":"https://schema.org","@type":"SoftwareApplication","name":"Cinemagraph Pro for iOS","description":"The best app to create cinemagraphs on iOS for getting noticed in social media and digital advertising. Living photos on-the-go made fun, fast, and easy.","image":["https://cdn.flixel.com/static/static-web/CinemagraphProiOS_1_1.png","https://cdn.flixel.com/static/static-web/CinemagraphProiOS_4_3.png","https://cdn.flixel.com/static/static-web/CinemagraphProiOS_16_9.png"],"downloadUrl":"https://appstore.com/apps/cinemagraphpro","operatingSystem":"iOS 11.0 and higher","storageRequirements":"100 MB","applicationCategory":"https://schema.org/SoftwareApplication","aggregateRating":{"@type":"AggregateRating","ratingValue":"4.6","bestRating":"5.0","ratingCount":"11289"},"offers":{"@type":"Offer","price":"14.99","priceCurrency":"USD"}}',
          type: 'application/ld+json',
        },
      ],
    };
  },
  data() {
    return {
      modalShow: false,
      ytVideo: '',
      modalProduct: false,
    };
  },
  mounted() {
    $(window).ready(function () {
      $(window).scrollTop(0);
    });
  },
  methods: {
    ytModal($event) {
      $event.preventDefault();
      const ytURL = $event.currentTarget.getAttribute('href');
      const iframeURL = ytURL.split('v=')[1];
      const videoHeight = window.innerHeight - 200;
      const videoWidth = window.innerWidth - 200;

      this.modalShow = true;
      $('body').bind('touchmove', function (e) {
        e.preventDefault();
      });
      this.ytVideo = '<iframe height=' + videoHeight + ' width= ' + videoWidth + ' src="https://www.youtube.com/embed/' + iframeURL + '?rel=0&amp;autoplay=1" frameborder="0" allowfullscreen></iframe>';
    },
    overlay() {
      $('body').unbind('touchmove');
      this.modalShow = false;
      this.modalProduct = false;
    },
  },
  mixins: [productmixin],
  components: {
    'Brands': Brands,
    'getPlan': getPlan,
  },
};
</script>


// WEBPACK FOOTER //
// src/views/products/ios-fcp.vue